@switch (item.type) {
  @case (DashboardItemType.GRAPH) {
    <app-dashboard-graph-settings [item]="item"></app-dashboard-graph-settings>
  }
  @case (DashboardItemType.TEXT) {
    <app-dashboard-text-settings [item]="item"></app-dashboard-text-settings>
  }
  @case (DashboardItemType.IMAGE) {
    <app-dashboard-image-settings [item]="item"></app-dashboard-image-settings>
  }
  @case (DashboardItemType.VALUE_DISPLAY) {
    <app-dashboard-value-display-settings [item]="item"></app-dashboard-value-display-settings>
  }
  @case (DashboardItemType.MULTI_VALUE_DISPLAY) {
    <app-dashboard-multiple-value-display-settings
      [item]="item"
    ></app-dashboard-multiple-value-display-settings>
  }
}
